// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/subscription/payment.v2.proto (package no.jotta.openapi.subscription.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { ApplyVoucherRequest, ApplyVoucherResponse, CancelPaymentTicketRequest, CancelPaymentTicketResponse, ChangePaymentRequest, ChangePaymentResponse, CheckAndConfirmStripeRequest, CheckAndConfirmStripeResponse, CreateStripeIntentRequest, CreateStripeIntentResponse, CreateVippsIntentRequest, CreateVippsIntentResponse, DescribeVoucherRequest, DescribeVoucherResponse, GetOrderRequest, GetOrderResponse, GetPaymentInfoRequest, GetPaymentInfoResponse, GetSupportedPaymentMethodsRequest, GetSupportedPaymentMethodsResponse, ListOrdersRequest, ListOrdersResponse, PlaceOrderRequest, PlaceOrderResponse } from "./payment.v2_pb.js";
import { PingRequest, PingResponse } from "../ping_pb.js";
/**
 * GetPaymentInfo gets the currently active payment information.
 *
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.GetPaymentInfo
 */
export const getPaymentInfo = {
    localName: "getPaymentInfo",
    name: "GetPaymentInfo",
    kind: MethodKind.Unary,
    I: GetPaymentInfoRequest,
    O: GetPaymentInfoResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.GetSupportedPaymentMethods
 */
export const getSupportedPaymentMethods = {
    localName: "getSupportedPaymentMethods",
    name: "GetSupportedPaymentMethods",
    kind: MethodKind.Unary,
    I: GetSupportedPaymentMethodsRequest,
    O: GetSupportedPaymentMethodsResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.PlaceOrder
 */
export const placeOrder = {
    localName: "placeOrder",
    name: "PlaceOrder",
    kind: MethodKind.Unary,
    I: PlaceOrderRequest,
    O: PlaceOrderResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.CheckAndConfirmStripe
 */
export const checkAndConfirmStripe = {
    localName: "checkAndConfirmStripe",
    name: "CheckAndConfirmStripe",
    kind: MethodKind.Unary,
    I: CheckAndConfirmStripeRequest,
    O: CheckAndConfirmStripeResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * DEPRECATED: use CreateStripeIntent instead
 *
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.CreateSetupIntent
 */
export const createSetupIntent = {
    localName: "createSetupIntent",
    name: "CreateSetupIntent",
    kind: MethodKind.Unary,
    I: CreateStripeIntentRequest,
    O: CreateStripeIntentResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * CreateStripeIntent with Stripe for storing payment details for future usage.
 *
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.CreateStripeIntent
 */
export const createStripeIntent = {
    localName: "createStripeIntent",
    name: "CreateStripeIntent",
    kind: MethodKind.Unary,
    I: CreateStripeIntentRequest,
    O: CreateStripeIntentResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.CreateVippsIntent
 */
export const createVippsIntent = {
    localName: "createVippsIntent",
    name: "CreateVippsIntent",
    kind: MethodKind.Unary,
    I: CreateVippsIntentRequest,
    O: CreateVippsIntentResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.CancelPaymentTicket
 */
export const cancelPaymentTicket = {
    localName: "cancelPaymentTicket",
    name: "CancelPaymentTicket",
    kind: MethodKind.Unary,
    I: CancelPaymentTicketRequest,
    O: CancelPaymentTicketResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * ChangePayment method for recurring payments (subscription) using Stripe.
 * Payment Method submitted must first be setup with Stripe using SetupIntent,
 * See: CreateStripeIntent
 *
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.ChangePayment
 */
export const changePayment = {
    localName: "changePayment",
    name: "ChangePayment",
    kind: MethodKind.Unary,
    I: ChangePaymentRequest,
    O: ChangePaymentResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.ListOrders
 */
export const listOrders = {
    localName: "listOrders",
    name: "ListOrders",
    kind: MethodKind.Unary,
    I: ListOrdersRequest,
    O: ListOrdersResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.GetOrder
 */
export const getOrder = {
    localName: "getOrder",
    name: "GetOrder",
    kind: MethodKind.Unary,
    I: GetOrderRequest,
    O: GetOrderResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.DescribeVoucher
 */
export const describeVoucher = {
    localName: "describeVoucher",
    name: "DescribeVoucher",
    kind: MethodKind.Unary,
    I: DescribeVoucherRequest,
    O: DescribeVoucherResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.ApplyVoucher
 */
export const applyVoucher = {
    localName: "applyVoucher",
    name: "ApplyVoucher",
    kind: MethodKind.Unary,
    I: ApplyVoucherRequest,
    O: ApplyVoucherResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.subscription.v2.SubscriptionService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.subscription.v2.SubscriptionService"
    }
};
